<template>
  <div class="cm">
    <div class="disabledfle">
      <div id="footer">

        <p class="address_tel_fax">
          <span>地址：成都高新区合顺路2号IC设计产业园2栋1单元2204</span>
        </p>
<!--        <p class="email_wx">-->
<!--          <span>服务电话：138 1004 5132</span>-->
<!--        </p>-->
        <p class="email_wx">
          <span>公司官网：https://www.tineee.com</span>
        </p>
        <p class="copy">Copyright &copy; 2025 - {{ new Date().getFullYear() }} 四川天烨智芯科技有限公司</p>
      </div>
<!--      <div class="logsq">-->
<!--        <img src="@/assets/img/web.png" alt="logo图">-->
<!--      </div>-->
    </div>

  </div>

</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.cm{
  background: #edf1f5;

}
.disabledfle{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}

#footer {
  height: 100%;
  color: #01202f;
}

.logsq img{
  width: 100px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #01202f;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #01202f;
  font-size: 14px;
}
.copy {
  color: #01202f;
  font-size: 14px;
  margin: 10px 0 20px;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .cm{
    width: 100%;
    background: #edf1f5;
  }
  .disabledfle{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    align-content: center;
  }
  #footer {
    width: 96%;
    color: #01202f;
    overflow: hidden;
    text-align: left;
  }

}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .cm{
    width: 100%;
    background: #edf1f5;
  }
  #footer {
    width: 96%;
    color: #01202f;
    overflow: hidden;
    text-align: left;
  }
  .disabledfle{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
  }

}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue